import {useSelector} from 'react-redux';
import Selector from '../../selectors/pages/main/balance';

export default () => {
    const {wallet} = useSelector(Selector);

    return (
        <div className="support" onClick={e => {
            let url = "https://t.me/casinos_support_bot";
            if(wallet.project === "the_mask") url = "https://t.me/R1927P";

            window.open(url, '_blank')
        }}>
            <div className="left">
                <img src={`${window.location.origin}/images/support.jpg`} />
                <div className="info">
                    <div className="name">
                        Online Manager <div className="dot animate__animated animate__pulse animate__infinite"></div>
                    </div>
                    <div className="lore">
                        Text if any questions
                    </div>
                </div>
            </div>
            <div className="right">
                24/7
            </div>
        </div>
    )
}